import { render, staticRenderFns } from "./quote-plan-list.vue?vue&type=template&id=0f64bd43&scoped=true&"
import script from "./quote-plan-list.vue?vue&type=script&lang=js&"
export * from "./quote-plan-list.vue?vue&type=script&lang=js&"
import style0 from "./quote-plan-list.vue?vue&type=style&index=0&id=0f64bd43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f64bd43",
  null
  
)

export default component.exports